import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumb({ items }) {
  useEffect(() => {
    const origin = window.location.origin;
    const data = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((item, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: item.label,
        ...(item.to ? { item: `${origin}${item.to}` } : {}),
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-breadcrumb", "true");
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      document.head.querySelectorAll('script[data-breadcrumb="true"]').forEach((s) => s.remove());
    };
  }, [items]);

  return (
    <nav aria-label="Fil d'Ariane" className="bg-bone border-b border-midnight/10" data-testid="breadcrumb">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-3">
        <ol className="flex flex-wrap items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-steel">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight size={12} strokeWidth={1.5} className="text-signal" />}
              {item.to ? (
                <Link to={item.to} className="hover:text-signal transition-colors duration-300">
                  {item.label}
                </Link>
              ) : (
                <span className="text-midnight/80" aria-current="page">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
